import React from 'react';
import './header-bar.css';
import Logo from "../logo/logo";
import {ReactComponent as CopyIcon} from './copy.svg';
import documentEventAdapter from "../../services/document-global";


function HeaderBar({room, detailClass, showAvatar}) {
    return (
        <div className="header-bar">
            {showAvatar &&
                <div className={'class-name'}>
                    <img src={`/img/max-class/${detailClass?.imagem_classe}`} />
                    <p>{detailClass?.nome}</p>
                </div>
            }
            {room &&
                <div className={'room-id'} onClick={() => {
                    documentEventAdapter.copy(room);
                }} title={'Clique para copiar'}>
                    <b>ID de sala:</b> {room} <CopyIcon style={{fill: 'white'}} className="copy-icon"/>
                </div>
            }
            <Logo className="logo"/>
        </div>
    );
}

export default HeaderBar;